<template>
  <div id="app">
    <router-view v-if="isrouterview" />
  </div>
</template>

<script>
export default {
  name: 'App',
  provide(){
    return{
      reload:this.reload
    }
  },
  data() {
    return {
      isrouterview: true,
    };
  },
  computed: {
    count() {
      return this.$store.lange
    },
  },
  watch: {
    count() {
      this.isrouterview = false;
      this.$nextTick(function () {
        this.isrouterview = true;
      });
    },
  },
  mounted () {
    // //接口判断主题，此处为设定默认样式
    // var themesCss = localStorage.getItem('cssStyle');
    // if(themesCss){
      // require("./assets/css/" + 'primary' + "/style.scss");
    // }
  },
  methods:{
    reload(){
      // var themesCss = localStorage.getItem('cssStyle');
      // console.log(themesCss)
      // require("./assets/css/" + themesCss + "/style.scss");
      this.isrouterview = false;
      this.$nextTick(function () {
        this.isrouterview = true;
      });
    }
  }
}
</script>

<style >
@import "./assets/css/main.css";
@import "./assets/css/color-dark.css";
@import "./assets/css/iconfont/iconfont.css";
.el-menu-item.is-active {
   background-color: rgb(20, 100, 197) !important;
}
.el-tooltip__popper {
    max-width: 40% !important;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 19;
    -webkit-box-orient: vertical;
  }
  .red{color: red;}
	.mTop10{margin-top: 10px;}
  .Width200{width: 2rem;}
  .datapicker{z-index: 999999 !important;}
  .headselect.el-select-dropdown.el-popper{
    z-index: 9999999 !important;
  }
  :root {
      --sldebarLeft: 230px;
      --custom-color: #59adf7;
      --border-color:#4ca3f0;
  }
  .el-tree-node.is-current.is-focusable{
    background: #f3f4f5;
  }
  .container .wRem3{
    width: 2rem !important;
  }
  .w-4{
    width: 4rem;
  }
  .w-2{
    width: 2rem;
  }
  .p-2{
    padding: 20px;
    box-sizing: border-box;
  }
  .pa-2{
    padding: 20px;
  }
  .mb-2{
    margin-bottom: 20px;
  }
  .m-y-2{
    margin: 20px 0;
  }
  .d-block{
    display: block;
    width: 100%;
  }
  .tags-li.active{
    background-color:var(--custom-color);
    border-color: var(--border-color);
  }
  .el-button--primary{
    background-color:var(--custom-color);
    border-color: var(--border-color);
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active{
    background-color:var(--custom-color);
  }
</style>



// WEBPACK FOOTER //
// src/App.vue